export const formatDate = (date)=>{
  const fecha = new Date(date);
  return fecha.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
  });
}